import React from 'react';
import moment from 'moment';
import ApplicationStatisticsContainer from '../../../state/containers/ApplicationStatisticsContainer';
import { TabPanel } from 'react-tabs';
import AnalyticsInterval from '../../../models/analytics/AnalyticsInterval';
import { MeasurementType } from '../../../components/analytics/MeasurementTypePicker';
import ScrollablePanelBody from '../../../components/structure/ScrollablePanelBody';
import TabbedLayout from '../../../components/structure/TabbedLayout';
import ApplicationUserCharts from './ApplicationUserCharts';
import ApplicationUserAnalyticsContainer from '../../../state/containers/ApplicationUserAnalyticsContainer';
import ApplicationInteractionsCharts from './ApplicationInteractionsCharts';
import ApplicationInteractionAnalyticsContainer from '../../../state/containers/ApplicationInteractionAnalyticsContainer';
import ApplicationStatistics from './ApplicationStatistics';
import FeatureContainer from '../../../state/containers/FeatureContainer';
import ApplicationMissAnalyticsContainer from '../../../state/containers/ApplicationMissAnalyticsContainer';
import ApplicationMissCharts from './ApplicationMissCharts';
import { DATE_FORMAT } from '../../../models/analytics/AnalyticsDateFormat';
import AnalyticsRequestFilter from '../../../models/analytics/AnalyticsRequestFilter';
import SsmlContainer from '../../../state/containers/SsmlContainer';
import UserApplicationPreferencesContainer from '../../../state/containers/UserApplicationPreferencesContainer';
import SessionAnalyticsWrapper from './SessionAnalyticsWrapper';
import ApplicationEnvironmentsContainer from '../../../state/containers/ApplicationEnvironmentsContainer';
import ApplicationModel from '../../../models/applications/api/ApplicationModel';
import ApplicationLiveSessions from './ApplicationLiveSessions';

interface ApplicationMeasurementPageProps {
    applicationId: string
    userAnalyticsContainer: ApplicationUserAnalyticsContainer
    interactionAnalyticsContainer: ApplicationInteractionAnalyticsContainer
    missAnalyticsContainer: ApplicationMissAnalyticsContainer
    statisticsContainer: ApplicationStatisticsContainer
    ssmlContainer: SsmlContainer
    userApplicationPreferencesContainer: UserApplicationPreferencesContainer
    featureContainer: FeatureContainer
    interval: AnalyticsInterval
    filter: AnalyticsRequestFilter
    history?: any
    envContainer: ApplicationEnvironmentsContainer
    application: ApplicationModel
}
interface ApplicationMeasurementPageState {
}
class ApplicationMeasurementPage extends React.Component<ApplicationMeasurementPageProps, ApplicationMeasurementPageState> {
    handleTabSelection(index: number, last: number) {
        if (index == last) return;
        const urlStart = `/v/apps/${this.props.applicationId}/analytics/`;

        if (index == 0) {
            this.props.history.push(urlStart + "activity" + window.location.search)
        }
        if (index == 1) {
            this.props.history.push(urlStart + "users" + window.location.search)
        }
        if (index == 2) {
            this.props.history.push(urlStart + "sessions" + window.location.search)
        }
        if(index == 3) {
            this.props.history.push(urlStart + "misses" + window.location.search)
        }
        if(index == 4) {
            this.props.history.push(urlStart + "report" + window.location.search)
        }
        if (index == 5) {
            this.props.history.push(urlStart + "live")
        }
    }
    getSelectedIndex() {
        if (location.href.indexOf("users") > -1) {
            return 1;
        }
        if (location.href.indexOf("sessions") > -1) {
            return 2;
        }
        if (location.href.indexOf("misses") > -1) {
            return 3;
        }
        if (location.href.indexOf("report") > -1) {
            return 4;
        }
        if (location.href.indexOf("live") > -1) {
            return 5;
        }

        return 0;
    }

    getInnerInterval(startDate: string, endDate: string): AnalyticsInterval {
        // rule of 3s.
        // if we are under 3 days, use hours **NOTE: now using days and hours if more then 1 day because Nivo groups the same x axis values together and renders them as 1
        // if we are under 3 months, use days
        // if we are under 3 years, use months
        // use years

        // get hours between dates
        const hoursBetween = moment(endDate, DATE_FORMAT).diff(moment(startDate, DATE_FORMAT), 'hours');
        if(hoursBetween <= 24) {
            return "hour";
        }
        if(hoursBetween <= (24 * 2))
        {
            return "dayAndHour"
        }
        if(hoursBetween <= (24 * 3 * 30)) {
            return "day"
        }
        if(hoursBetween <= (24 * 3 * 365)) {
            return "month"
        }
        return "year"
    }

    handleMeasurementTypeChange(type: MeasurementType) {
        this.setState({
            ...this.state,
            measurementType: type
        })
    }

    render() {
        const innerInterval = this.getInnerInterval(this.props.filter.startDate, this.props.filter.endDate);
        return (
            <ScrollablePanelBody>
                <TabbedLayout tabs={["Activity", "Users", "Sessions", "Misses", "Report", "Live"]} top
                            selectedIndex={this.getSelectedIndex()}
                            onTabSelected={this.handleTabSelection.bind(this)}>
                    <TabPanel>
                        <ApplicationInteractionsCharts filter={this.props.filter} interval={this.props.interval} innerInterval={innerInterval} stateContainer={this.props.interactionAnalyticsContainer} applicationId={this.props.applicationId} />
                    </TabPanel>
                    <TabPanel>
                        <ApplicationUserCharts filter={this.props.filter} interval={this.props.interval} innerInterval={innerInterval} stateContainer={this.props.userAnalyticsContainer} applicationId={this.props.applicationId} />
                    </TabPanel>
                    <TabPanel>
                        <SessionAnalyticsWrapper
                            filter={this.props.filter}
                            interval={this.props.interval}
                            innerInterval={innerInterval}
                            ssmlContainer={this.props.ssmlContainer}
                            envContainer={this.props.envContainer}
                            history={this.props.history}
                            userApplicationPreferencesContainer={this.props.userApplicationPreferencesContainer}
                            applicationId={this.props.applicationId} />
                    </TabPanel>
                    <TabPanel> 
                        <ApplicationMissCharts filter={this.props.filter} interval={this.props.interval} innerInterval={innerInterval} stateContainer={this.props.missAnalyticsContainer} applicationId={this.props.applicationId} />
                    </TabPanel>
                    <TabPanel>
                        <ApplicationStatistics
                            application={this.props.application}
                            filter={this.props.filter}
                            interval={this.props.interval}
                            innerInterval={innerInterval}
                            featureContainer={this.props.featureContainer}
                            stateContainer={this.props.statisticsContainer}
                            applicationId={this.props.applicationId}
                            ssmlContainer={this.props.ssmlContainer}
                            envContainer={this.props.envContainer}
                            history={this.props.history}
                            userApplicationPreferencesContainer={this.props.userApplicationPreferencesContainer} />
                    </TabPanel>
                    <TabPanel>
                        <ApplicationLiveSessions
                            history={this.props.history}
                            applicationId={this.props.applicationId}/>
                    </TabPanel>
                </TabbedLayout>
            </ScrollablePanelBody>
        )
    }
}

export default ApplicationMeasurementPage;